import { Popover } from 'antd';
import styled from 'styled-components';
export const AutoHideContainer = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__AutoHideContainer",
  componentId: "sc-1jkqa42-0"
})(["", " background-color:rgba(255,255,255,0.85);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);"], {
  "position": "fixed",
  "left": "0px",
  "right": "0px",
  "top": "0px",
  "zIndex": "41",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
});
export const HeaderLayoutContainer = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__HeaderLayoutContainer",
  componentId: "sc-1jkqa42-1"
})(["", " max-width:", ";@media (max-width:", "){", "}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "width": "100%",
  "userSelect": "none",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => `${theme.layout.width}`, ({
  theme
}) => theme.breakpoint.lg, {
  "height": "3.5rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem"
});
export const LeftSide = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__LeftSide",
  componentId: "sc-1jkqa42-2"
})(["", ""], {
  "display": "flex",
  "height": "100%",
  "alignItems": "stretch"
});
export const MiddleSide = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__MiddleSide",
  componentId: "sc-1jkqa42-3"
})(["", " @media (max-width:", "){", "}"], {
  "display": "flex",
  "gap": "1rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "display": "none"
});
export const RightSide = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__RightSide",
  componentId: "sc-1jkqa42-4"
})(["", ""], {
  "display": "flex"
});
export const ButtonMenuContainer = styled.div.withConfig({
  displayName: "HeaderLayoutstyle__ButtonMenuContainer",
  componentId: "sc-1jkqa42-5"
})(["", " div{", "}button{", " border:", ";}span{", "}button:first-child:hover{", "}"], {
  "display": "flex",
  "gap": "0.75rem"
}, {
  "display": "flex",
  "height": "2.5rem",
  "cursor": "pointer",
  "alignItems": "center",
  "whiteSpace": "nowrap"
}, {
  "display": "flex",
  "height": "2.5rem",
  "cursor": "pointer",
  "alignItems": "center"
}, ({
  theme
}) => `1px solid ${theme.colors.grey[20]}`, {
  "display": "block"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
});
export const Custom = {
  Button: styled.div.withConfig({
    displayName: "HeaderLayoutstyle__Button",
    componentId: "sc-1jkqa42-6"
  })(["", " border:", " !important;span{", "}&:disabled{", "}"], {
    "borderRadius": "0.5rem",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(167 167 167 / var(--tw-border-opacity, 1))",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.375rem",
    "paddingBottom": "0.375rem"
  }, ({
    theme
  }) => `1px solid ${theme.colors.grey[20]}`, {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem"
  }, {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(167 167 167 / var(--tw-border-opacity, 1))",
    "backgroundColor": "transparent"
  }),
  Popover: styled(Popover).withConfig({
    displayName: "HeaderLayoutstyle__Popover",
    componentId: "sc-1jkqa42-7"
  })([".ant-popover-inner{", "}"], {
    "padding": "0px"
  })
};